import React from 'react';
import { motion } from 'framer-motion';
import { PlayCircle, Smartphone, BookOpen, ShieldCheck, Clock, ArrowRight } from 'lucide-react';
import { Button, Countdown } from './ui';
const CHECKOUT_URL = 'https://sistema-iphone-ads.myshopify.com/cart/add?id=46176935641285&quantity=1&return_to=/cart';
const HeroVideo = ({
  className = ''
}: {
  className?: string;
}) => <div className={`relative w-full max-w-sm mx-auto aspect-[9/16] rounded-3xl shadow-xl md:shadow-[0_20px_50px_rgba(0,0,0,0.5)] overflow-hidden group border border-blue-500/20 bg-zinc-900 ${className}`} data-id="element-58">
    <video autoPlay muted loop playsInline preload="metadata" className="absolute inset-0 w-full h-full object-cover" data-id="element-59">
      <source src="https://cdn.magicpatterns.com/uploads/c3MnEZ7pGSwvHZU1pZ7Ssb/ugly-ad-5_THMHkXmO.mp4" type="video/mp4" data-id="element-60" />
    </video>

    {/* Dark Overlays */}
    <div className="absolute inset-0 bg-gradient-to-t from-zinc-950 via-zinc-950/20 to-transparent pointer-events-none" data-id="element-61"></div>
    <div className="absolute inset-0 bg-blue-900/10 mix-blend-overlay pointer-events-none" data-id="element-62"></div>

    {/* Top Badge */}
    <div className="absolute top-5 left-1/2 -translate-x-1/2 bg-zinc-900/90 backdrop-blur-md border border-zinc-700/50 rounded-full px-4 py-1.5 shadow-lg whitespace-nowrap z-10" data-id="element-63">
      <span className="text-xs font-bold text-zinc-200 uppercase tracking-wider" data-id="element-64">
        REFERENCIA REAL
      </span>
    </div>

    {/* Bottom Text */}
    <div className="absolute bottom-6 left-0 right-0 px-6 text-center z-10" data-id="element-65">
      <p className="text-sm font-medium text-white drop-shadow-md bg-zinc-950/60 backdrop-blur-sm py-2 px-3 rounded-xl border border-white/[0.05]" data-id="element-66">
        Así se ve aplicado en una tienda que ya trabaja con nosotros.
      </p>
    </div>
  </div>;
export const Hero = () => {
  return <section className="relative pt-20 pb-12 md:pt-32 md:pb-24 px-6 md:px-12 max-w-7xl mx-auto overflow-hidden" data-id="element-67">
      {/* Background Glow - Reduced on mobile */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] md:w-[800px] h-[400px] md:h-[800px] bg-blue-500/15 rounded-full blur-[60px] md:blur-[120px] -z-10 pointer-events-none" data-id="element-68" />

      <div className="grid lg:grid-cols-2 gap-10 lg:gap-8 items-center" data-id="element-69">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col space-y-8" data-id="element-70">
          <div className="inline-flex items-center space-x-2 bg-zinc-900/80 border border-zinc-800 rounded-full px-4 py-2 w-fit" data-id="element-71">
            <span className="flex h-2 w-2 rounded-full bg-blue-500 animate-pulse" data-id="element-72"></span>
            <span className="text-sm font-medium text-zinc-300" data-id="element-73">
              Sistema iPhone Ads
            </span>
          </div>

          <p className="text-sm md:text-base font-semibold text-blue-300" data-id="element-74">
            Empezá sin stock, vendé por pedido y aprendé a conseguir clientes.
          </p>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-[1.1]" data-id="element-75">
            Antes de comprar tu primer iPhone,{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-blue-600" data-id="element-76">
              aprendé cómo venderlo
            </span>
          </h1>

          <p className="text-lg md:text-xl text-zinc-400 leading-relaxed" data-id="element-77">
            Un curso práctico para entender el negocio de los iPhones, vender
            sin stock propio, evitar comprar mal y conseguir clientes usando
            Instagram, WhatsApp y Meta Ads.
          </p>

          {/* Compact steps line */}
          <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-sm font-medium text-zinc-300" data-id="element-78">
            <span data-id="element-79">Sin stock</span>
            <ArrowRight className="w-3.5 h-3.5 text-zinc-600" data-id="element-80" />
            <span data-id="element-81">Venta por pedido</span>
            <ArrowRight className="w-3.5 h-3.5 text-zinc-600" data-id="element-82" />
            <span data-id="element-83">Clientes por redes</span>
          </div>

          <div className="flex items-center text-sm md:text-base font-medium text-emerald-400" data-id="element-84">
            <ShieldCheck className="w-4 h-4 mr-2 flex-shrink-0" data-id="element-85" />
            <span data-id="element-86">
              Curso grabado · Acceso inmediato · Precio especial $19.000
            </span>
          </div>

          <div className="bg-zinc-900/40 border border-white/[0.05] rounded-3xl p-6 md:p-8 backdrop-blur-sm md:backdrop-blur-md shadow-lg md:shadow-2xl relative overflow-hidden" data-id="element-87">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-blue-500 via-emerald-500 to-blue-500" data-id="element-88"></div>

            <div className="flex flex-col space-y-6" data-id="element-89">
              <div data-id="element-90">
                <p className="text-sm text-blue-400 font-semibold uppercase tracking-wider mb-2" data-id="element-91">
                  Precio especial de lanzamiento
                </p>
                <div className="flex items-baseline space-x-3" data-id="element-92">
                  <span className="text-4xl md:text-5xl font-extrabold text-white" data-id="element-93">
                    $19.000
                  </span>
                  <span className="text-lg text-zinc-500 line-through" data-id="element-94">
                    $40.000
                  </span>
                </div>
                <div className="mt-3 space-y-1" data-id="element-95">
                  <p className="text-sm font-medium text-zinc-300" data-id="element-96">
                    Acceso inmediato al curso grabado.
                  </p>
                  <p className="text-sm font-semibold text-emerald-400" data-id="element-97">
                    Más de 50% OFF por tiempo limitado.
                  </p>
                </div>
              </div>

              <Countdown data-id="element-98" />

              <div className="pt-2" data-id="element-99">
                <Button href={CHECKOUT_URL} className="w-full py-5 text-xl shadow-[0_0_30px_rgba(16,185,129,0.2)]" data-id="element-100">
                  Acceder ahora por $19.000
                </Button>
                <div className="mt-4 space-y-2 text-center" data-id="element-101">
                  <p className="text-sm font-medium text-zinc-300" data-id="element-102">
                    Recibís el acceso automáticamente por mail después de la
                    compra.
                  </p>
                  <p className="text-xs text-zinc-500" data-id="element-103">
                    Curso grabado · Acceso inmediato · Sin acompañamiento
                    personalizado
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Mobile Video: appears after price block */}
          <HeroVideo className="lg:hidden mt-4" data-id="element-104" />

          <div className="flex flex-wrap gap-4 pt-2" data-id="element-105">
            <div className="flex items-center text-sm text-zinc-400" data-id="element-106">
              <ShieldCheck className="w-4 h-4 mr-2 text-emerald-500" data-id="element-107" /> Acceso
              digital
            </div>
            <div className="flex items-center text-sm text-zinc-400" data-id="element-108">
              <PlayCircle className="w-4 h-4 mr-2 text-emerald-500" data-id="element-109" /> Curso
              grabado
            </div>
            <div className="flex items-center text-sm text-zinc-400" data-id="element-110">
              <BookOpen className="w-4 h-4 mr-2 text-emerald-500" data-id="element-111" /> Clases +
              materiales prácticos
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative lg:h-[600px] hidden lg:flex items-center justify-center mt-8 lg:mt-0" data-id="element-112">
          {/* Desktop Video: replaces the static image */}
          <HeroVideo className="max-w-md" data-id="element-113" />
        </motion.div>
      </div>
    </section>;
};